import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { StrapiFdp } from './types';

export const FDP_TEMPLATES_KEY = 'fdpTemplates';

function getFdpTemplates() {
  const requestURL = '/cms/fiches-de-prep';
  return request(requestURL, {
    method: 'GET',
  }).then<StrapiFdp[]>(({ data }) => data);
}

export function useFdpTemplates() {
  return useQuery({
    queryKey: [FDP_TEMPLATES_KEY],
    queryFn: () => getFdpTemplates(),
    placeholderData: undefined,
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
}
